import Sign from "@/modules/authentication/Sign";

export default {
    signin: {
        path: "/signin",
        name: "Signin",
        component: Sign,
    },
    signup: {
        path: "/signup",
        name: "Signup",
        component: Sign,
    },
    resetpassword: {
        path: "/resetpassword/:token",
        name: "ResetPassword",
        component: Sign
    },
    forgotpassword: {
        path: "/forgotpassword",
        name: "ForgotPassword",
        component: Sign
    },

};